module.exports = __webpack_public_path__ + "images/92f4de47f6f6fdf1965631e6fcef33f9-Roboto-Italic.svg";